import React from "react";

import heide from "../img/cards/heide.png";
import lindemeier from "../img/cards/lindemeier.png";
import busley from "../img/cards/busley.png";
import eva from "../img/cards/eva.png";

export default class UberUns extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <h2>Was zeichnet mein Unternehmen besonders aus?</h2>
        <p>
          Kreativität und Wissen, wie es geht: Ich weiß, wie es praktisch funktioniert, sich, andere und Teams sinnvoll und nachhaltig
          weiter zu entwickeln und ich/wir können dies gehirngerecht und motivierend vermitteln, mit Verstand und Humor.
        </p>
        <p>
          Ich und meine Partner, wir greifen für die Fortbildungsangebote auf langjährige Berufspraxis zu, sowohl im Einzel-Coaching als
          auch im Training und der Aus- und Weiterbildung, sowohl in der freien Wirtschaft als auch im Hochschulbereich und mit
          Privatkunden. Wir kennen unser Metier
        </p>
        <p>
          Wir arbeiten vergnügt und transparent und können erörtern, wieso etwas klappt und auf welchen Grundlagen es beruht. Wir arbeiten
          prozessorientiert und maßgeschneidert, Dynamiken sind uns vertraut, wir nutzen die Ressourcen und Fähigkeiten/Möglichkeiten, die
          vorhanden sind und bauen auf diesen auf. Wir machen uns entbehrlich und zeigen, wie Du/Ihr selber tun kannst/können.
        </p>
        <h2>Mein Team</h2>
        <div className="row">
          <div className="col-md-6 left person-card">
            <div className="inner" style={{ backgroundImage: `url(${heide})` }}>
              <div className="caption">
                HEIDE
                <br />
                JANOWITZ
                <ul className="attributes">
                  <li>Lehrcoach</li>
                  <li>Lehrtrainerin (DVNLP)</li>
                  <li>Hypnotherapie (Dr. W. Lenk, MEG)</li>
                  <li>Energetische Psychotherapie (Dr. F. Gallo)</li>
                  <li>Mediation (B. und E. Spangenberg, BAFM)</li>
                  <li>Entspannungstrainerin</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 right person-card">
            <div className="inner" style={{ backgroundImage: `url(${lindemeier})` }}>
              <div className="caption">
                DR. JÜRGEN
                <br />
                LINDEMEIER
                <ul className="attributes">
                  <li>Promotion in molekularer Neurobiologie</li>
                  <li>Forschungstätigkeit</li>
                  <li>Projektgestaltung</li>
                  <li>Strategieentwicklung</li>
                  <li>Geschäftsführer</li>
                  <li>seit 3 Jahren Partner bei Coaching for Competence®</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 left person-card">
            <div className="inner" style={{ backgroundImage: `url(${busley})` }}>
              <div className="caption">
                GUNDA
                <br />
                BUSLEY
                <ul className="attributes">
                  <li>systemische Supervisorin</li>
                  <li>
                    Coach und Organisationsberaterin („Supervisorin werden ist ein Prozess“ – Eckdaten auf der Webseite
                    www.supervision-busley.de)
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 right person-card">
            <div className="inner" style={{ backgroundImage: `url(${eva})` }}>
              <div className="caption">
                EVA-MARIA
                <br />
                SCHUHMACHER
                <ul className="attributes">
                  <li>Lehrcoach</li>
                  <li>Lehrtrainerin (DVNLP)</li>
                  <li>Supervisorin</li>
                  <li>Rollenspielleiterin</li>
                  <li>Provokatives Coaching (Noni Höfner) Hochschuldidaktikerin</li>
                  <li>Visual Facilitator / Graphic Recorder (Kommunikationslotsen)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
